export default `#version 300 es

// fragment shaders don't have a default precision so we need
// to pick one. highp is a good default. It means "high precision"
precision highp float;

// we need to declare an output for the fragment shader
out vec4 outColor;

uniform vec4 color;
// uniform float opacity;

void main() {
    vec4 finalColor = color;
    // finalColor.a = finalColor.a * opacity;
    outColor = finalColor;
}
`